<template>
    <div>
        <div v-if="isLoading" class="text-center my-3">
            <b-spinner small class="mr-2" />Memuat data barang...
        </div>
        <b-row v-show="!isLoading">
            <b-col md="4">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Jenis <span class="text-danger">*</span>
                    </template>
                    <multiselect
                        v-model="kind"
                        label="name"
                        track-by="id"
                        :allow-empty="false"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        placeholder="Pilih jenis..."
                        :options="optKind"
                        @input="onKindChange"
                    />
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Merk <span class="text-danger">*</span>
                    </template>
                    <multiselect
                        v-model="brand"
                        label="name"
                        track-by="id"
                        :allow-empty="false"
                        :internal-search="true"
                        :disabled="!kind"
                        deselect-label=""
                        select-label=""
                        placeholder="Pilih merk..."
                        :options="optBrand"
                        @input="onBrandChange"
                    />
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Tipe <span class="text-danger">*</span>
                    </template>
                    <multiselect
                        v-model="type"
                        label="name"
                        track-by="id"
                        :allow-empty="false"
                        :internal-search="true"
                        :disabled="!brand"
                        deselect-label=""
                        select-label=""
                        placeholder="Pilih tipe..."
                        :options="optType"
                        @input="onTypeChange"
                    />
                </b-form-group>
            </b-col>
            <b-col v-if="type && type.has_year" md="3">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Tahun / Generasi <span class="text-danger">*</span>
                    </template>
                    <b-form-select v-model="input.year" :options="optYear">
                        <template #first>
                            <b-select-option :value="null" disabled>Pilih tahun...</b-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Grade <span class="text-danger">*</span>
                    </template>
                    <b-form-select v-model="input.grade" :options="optGrade">
                        <template #first>
                            <b-select-option :value="null" disabled>Pilih grade...</b-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Spec <span class="text-danger">*</span>
                    </template>
                    <b-form-select v-model="input.spec_id" :options="optSpec" :disabled="!type">
                        <template #first>
                            <b-select-option :value="null" disabled>Pilih spec...</b-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Kelengkapan" label-class="font-weight-bold">
                    <b-form-select v-model="input.is_batangan" :options="optBatangan" />
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        Warna <span class="text-danger">*</span>
                    </template>
                    <b-form-select v-model="input.color_id" :options="optColor">
                        <template #first>
                            <b-select-option :value="null" disabled>Pilih warna...</b-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label-class="font-weight-bold">
                    <template #label>
                        IMEI / SN <span class="text-danger">*</span>
                    </template>
                    <b-input v-model="input.imei_sn" maxlength="100" />
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Password" label-class="font-weight-bold">
                    <b-input v-model="input.password" maxlength="100" />
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="Deskripsi" label-class="font-weight-bold">
                    <b-form-textarea v-model="input.description" rows="2" max-rows="4" />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "FormDataTemuan",
    props: {
        // Same shape as origin_data / sm_data from the BE contract.
        defaults: { type: Object, default: null }
    },
    data() {
        return {
            isLoading: false,
            kind: null,
            brand: null,
            type: null,
            input: {
                year: null,
                grade: null,
                spec_id: null,
                is_batangan: false,
                color_id: null,
                imei_sn: "",
                password: "",
                description: ""
            },
            optKind: [],
            optBrand: [],
            optType: [],
            optYear: [],
            optSpec: [],
            optColor: [],
            optGrade: ["S", "A", "B", "C", "D", "E", "X"],
            optBatangan: [
                { value: false, text: "Lengkap" },
                { value: true, text: "Batangan" }
            ]
        };
    },
    watch: {
        kind(value) {
            this.$emit("kind-change", value ? value.id : null);
        },
        "input.grade"(value) {
            this.$emit("grade-change", value);
        }
    },
    created() {
        // Modal content is re-created on every open, so this runs per open.
        this.load(this.defaults || {});
    },
    methods: {
        get(url) {
            return this.$axios.get(url).then(res => res.data.data);
        },

        async load(d) {
            this.isLoading = true;
            this.input = {
                year: d.year || null,
                grade: d.grade || null,
                spec_id: d.spec_id || null,
                is_batangan: Boolean(Number(d.is_batangan)),
                color_id: d.color_id || null,
                imei_sn: d.imei_sn || "",
                password: d.password || "",
                description: d.description || ""
            };

            try {
                const [kinds, colors] = await Promise.all([
                    this.get("master/kinds?category=ELEK"),
                    this.get("master/color/selection")
                ]);
                this.optKind = kinds;
                this.optColor = colors.map(it => ({ value: it.id, text: it.name }));

                this.kind = kinds.find(it => it.id == d.item_kind_id) || null;
                if (!this.kind) return;

                this.optBrand = await this.get(`master/brands/${this.kind.id}`);
                this.brand = this.optBrand.find(it => it.id == d.item_brand_id) || null;
                if (!this.brand) return;

                this.optType = await this.get(`master/types/${this.brand.id}`);
                this.type = this.optType.find(it => it.id == d.item_type_id) || null;
                if (!this.type) return;

                await this.loadTypeOptions();
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isLoading = false;
            }
        },

        async loadTypeOptions() {
            const [years, specs] = await Promise.all([
                this.type.has_year ? this.get(`master/years/${this.type.id}`) : Promise.resolve([]),
                this.get(`master/type-price/${this.type.id}`)
            ]);
            this.optYear = years.map(it => ({ value: it.year, text: it.year }));
            this.optSpec = specs.map(it => ({ value: it.id, text: it.name }));
        },

        resetTypeOptions() {
            this.input.year = null;
            this.input.spec_id = null;
            this.optYear = [];
            this.optSpec = [];
        },

        onKindChange() {
            this.brand = null;
            this.type = null;
            this.optBrand = [];
            this.optType = [];
            this.resetTypeOptions();
            this.get(`master/brands/${this.kind.id}`)
                .then(data => (this.optBrand = data))
                .catch(error => this.$helper.parseError(this, error));
        },

        onBrandChange() {
            this.type = null;
            this.optType = [];
            this.resetTypeOptions();
            this.get(`master/types/${this.brand.id}`)
                .then(data => (this.optType = data))
                .catch(error => this.$helper.parseError(this, error));
        },

        onTypeChange() {
            this.resetTypeOptions();
            this.loadTypeOptions().catch(error => this.$helper.parseError(this, error));
        },

        // Returns an error message, or null when the form is valid.
        validate() {
            if (!this.kind || !this.brand || !this.type) return "Jenis, merk, dan tipe wajib dipilih";
            if (this.type.has_year && !this.input.year) return "Tahun / generasi wajib dipilih";
            if (!this.input.grade) return "Grade wajib dipilih";
            if (!this.input.spec_id) return "Spec wajib dipilih";
            if (!this.input.color_id) return "Warna wajib dipilih";
            if (!this.input.imei_sn.trim()) return "IMEI / SN wajib diisi";
            return null;
        },

        getData() {
            return {
                item_kind_id: this.kind.id,
                item_brand_id: this.brand.id,
                item_type_id: this.type.id,
                year: this.type.has_year ? this.input.year : null,
                grade: this.input.grade,
                spec_id: this.input.spec_id,
                is_batangan: this.input.is_batangan,
                color_id: this.input.color_id,
                imei_sn: this.input.imei_sn.trim(),
                password: this.input.password || null,
                description: this.input.description || null
            };
        }
    }
};
</script>
